import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PaginatedResults } from '../../models/paginated_results_model';
import { PaginationOptions } from '../../models/pagination_options';
import { FundRule } from '../../models/fund-rule';
import { getCurrentApiDomain } from '../../helpers/helper-functions';

@Injectable({
  providedIn: 'root',
})
export class FundRuleService {
  apiUrl = getCurrentApiDomain('/general');


  constructor(private http: HttpClient) { }

  searchModifiers(paginationOptions: PaginationOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
      `/search-modifiers?${PaginationOptions.getPaginationQueryParameters(
        paginationOptions
      )}`,
      options
    );
  }


  show(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<FundRule>(
      this.apiUrl + `/fund-rules/${uuid}`,
      options
    );
  }
}
